import { render } from "./RecipeImagegen.vue?vue&type=template&id=760615c5&scoped=true"
import script from "./RecipeImagegen.vue?vue&type=script&lang=js"
export * from "./RecipeImagegen.vue?vue&type=script&lang=js"

import "./RecipeImagegen.vue?vue&type=style&index=0&id=760615c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760615c5"]])

export default __exports__